import { mutatorAction } from 'satcheljs';
import store from '../store/store';
export default mutatorAction('setCreatedRule', function setCreatedRule(createdRule) {
    store.createdRule = createdRule;
});
//# sourceMappingURL=setCreatedRule.js.map